'use client'

import { useQuery } from '@tanstack/react-query'
import { getPeople } from './people-action'
import type { Database } from '@/account'

type Person = Database['public']['Tables']['people']['Row']

export const PEOPLE_QUERY_KEY = ['people'] as const

/**
 * Hook to fetch all people for the current user.
 * Uses React Query for caching and automatic refetching.
 */
export function usePeople() {
  return useQuery<Person[], Error>({
    queryKey: PEOPLE_QUERY_KEY,
    queryFn: () => getPeople(),
    staleTime: 1000 * 60 * 5, // Consider fresh for 5 minutes
  })
}
